import { render, staticRenderFns } from "./TransitionSection.vue?vue&type=template&id=44a67ae4&scoped=true&"
import script from "./TransitionSection.vue?vue&type=script&lang=js&"
export * from "./TransitionSection.vue?vue&type=script&lang=js&"
import style0 from "./TransitionSection.vue?vue&type=style&index=0&id=44a67ae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a67ae4",
  null
  
)

export default component.exports